export const slice = (value, lang, start, end) =>
	typeof value === "string" ? value.slice(start, end) : value;

export const right = (value, lang, count) => slice(value, lang, -count, undefined);

export const left = (value, lang, count) => slice(value, lang, 0, count);
